import { CSSObject } from "@emotion/react";
import { constants, type AnchorStyleOverrides } from "@newsela/angelou";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const sectionContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  padding: "0 0.5rem",
};

export const mobileFullWidthCss = {
  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    width: "100%",
  },
};

export const sectionTitleCss: CSSObject = {
  fontSize: "1rem",
  color: constants.colors.ui.neutral[700],
  padding: 0,
  fontWeight: 700,
  margin: "0 0 0 0.5rem",
};

export const unorderedListCss: CSSObject = {
  padding: 0,
  margin: 0,
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
  listStyleType: "none",
};

export const iconAndTitleCss: CSSObject = {
  display: "flex",
  gap: "0.5rem",
  flexDirection: "row",
  alignItems: "flex-start",
};

export const anchorCss: AnchorStyleOverrides<CSSObject> = {
  root: {
    textDecoration: "none",
    display: "flex",
    margin: 0,
    padding: "0.25rem 0.5rem",
    width: "100%",
    borderRadius: "0.5rem",
    lineHeight: "1.5rem",
    color: constants.colors.ui.neutral[700],
    outline: "2px solid transparent",

    ":focus": {
      background: "#F1F7FF",
      outlineOffset: "2px",
      boxShadow: `0 0 0 2px ${constants.colors.ui.core[500]}`,
      outline: "none",
      zIndex: 2,
    },
    ":focus:not(:focus-visible)": {
      outline: "none",
    },
    ":hover": {
      background: "#F1F7FF",
    },
    ":focus-visible": {
      background: "#F1F7FF",
    },

    "> div": {
      width: "100%",
      display: "flex",
      gap: "0.5rem",
      justifyContent: "space-between",
      flexDirection: "row",
      alignItems: "center",
    },
  },
};
